import { DndState } from '../utils/dnd.utils'

export enum DnDActionType {
  mergeState = 'MERGE_STATE',
  replaceState = 'REPLACE_STATE',
}

export type DnDAction = {
  type: DnDActionType
  data: DndState
}

type Reducer = (state: DndState, action: DnDAction) => DndState

const mergeState: Reducer = (state, { data }) => {
  return { ...state, ...data }
}

const replaceState: Reducer = (_, { data }) => {
  return data
}

const reducers: Record<DnDActionType, Reducer> = {
  [DnDActionType.mergeState]: mergeState,
  [DnDActionType.replaceState]: replaceState,
}

export const reducer = (state: DndState, action: DnDAction): DndState => {
  return reducers[action.type](state, action)
}
